<template>
  <div class="serviceMaskBox" v-if="screenType === 'pc'">
    <div class="sBoxItem">
      <div class="sBoxTitle"
           v-for="(mItem,mIndex) in linkData" :key="mIndex"
           @click="handleLoanReservation(mItem)">
        {{ mItem.name }}
      </div>
    </div>
    <div class="el-popper__arrow"></div>
    <el-image :src="closeIcon" fit="cover" class="closeIcon" @click="handleCloseMask"></el-image>
  </div>
  <div class="sMobilePop" v-if="screenType === 'mobile' && flag">
    <van-popup v-model:show="flag" round position="bottom">
      <van-picker
          :columns="linkData"
          :columns-field-names="customFieldName"
          @cancel="flag = false"
          @confirm="handleOnConfirm"
      />
    </van-popup>
  </div>

</template>

<script setup>
import {defineExpose, defineProps, onMounted, ref} from "vue";
import router from "@/router";

import {eventBus} from "@/store/eventBus";

import {AdaptationScreen, loanAppointmentJumpConnection} from "@/common/js/config.default";
import {getBrandList} from "@/http/financialService/financialCalculation";

const closeIcon = require("@/assets/components/loanReservation/close.png")
const screenType = ref('pc');

const linkData = ref(loanAppointmentJumpConnection)
const flag = ref(false);

const customFieldName = {
  text: 'name',
  value: 'name',
}

const emit = defineEmits(['handleCloseMask', 'handleGetFinancialIndex'])

const props = defineProps({
  isJump: {
    type: Boolean,
    default: true
  },
})

const handleOpenMask = () => {
  flag.value = true
}

const handleCloseMask = () => {
  flag.value = false
  emit('handleCloseMask', false)
}

const handleLoanReservation = item => {
  //if (item.link) {
  //  window.open(item.link)
  //}

  if (props.isJump) {
    //if (item.noData) {
    //  return ElMessage({
    //    message: "敬请期待",
    //    type: "warning"
    //  })
    //}

      delete item.query.brandFinancialLogo

    router.push({
      path: item.link,
      query: {
        ...item.query,
        source:1
      }
    })
    eventBus.emit("financialIndex", item.query.financialIndex)
  } else {
    emit('handleGetFinancialIndex', item.query.financialIndex)
  }

}

const handleOnConfirm = (e) => {
  const name = e.selectedValues[0]
  const index = linkData.value.findIndex(item => item.name === name)
  const item = linkData.value[index];
  if (props.isJump) {
    router.push({
      path: item.link,
      query: {
        ...item.query,
        source: 1,//留资-官网
      }
    })
    eventBus.emit("financialIndex", item.query.financialIndex)
  } else {
    emit('handleGetFinancialIndex', item.query.financialIndex)
  }

  handleCloseMask();
}

const getBrandListFn = async () => {
  let res = await getBrandList();
  if (res.code === 200) {
    linkData.value.forEach(item => {
      res.data.forEach(cItem => {
        if (item.brandName === cItem.brandName) {
          item.query.brandFinancialLogo = cItem.brandFinancialLogo
        }
      })
    })
  }
}

defineExpose({
  handleOpenMask,
  handleCloseMask,
})

onMounted(() => {
  AdaptationScreen(() => {
    //console.log("手机")
    screenType.value = 'mobile'
  }, () => {
    //console.log("PC")
    screenType.value = 'pc'
  },);

  getBrandListFn();
})

</script>

<style scoped lang="scss">
@import "@/common/scss/breakpoints";

.serviceMaskBox {
  min-width: 240px;
  //height: 400px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 70%;
  transform: translateY(-50%);
  z-index: 9;
  background: var(--el-color-white);
  border: 1px solid var(--el-border-color-light);
  box-shadow: var(--el-box-shadow-light);

  .sBoxItem {
    list-style: none;
    margin: 6px 0 !important;
    padding: 0 !important;
    box-sizing: border-box;


  }

  .sBoxTitle {
    font-size: var(--el-font-size-base);
    padding: 0 32px 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--el-text-color-regular);
    height: 34px;
    line-height: 34px;
    box-sizing: border-box;
    cursor: pointer;

    &.hover {

    }

    &:hover {
      color: var(--el-color-primary);
      font-weight: 700;
      background-color: var(--el-bg-color);
    }
  }

  .el-popper__arrow {
    width: 10px;
    height: 10px;
    position: absolute;
    top: 50%;
    left: -5px;
    transform: translateY(-50%);
    z-index: -1;

    &:before {
      content: " ";
      background: var(--el-color-white);
      transform: rotate(45deg);
      box-sizing: border-box;
      position: absolute;
      width: 10px;
      height: 10px;
      z-index: -1;
      border: 1px solid var(--el-border-color-light);
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      right: 0;
    }
  }

  .closeIcon {
    width: 15px;
    height: 15px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
}

@include media-breakpoint-up("md") {
  @import "./index-md.scss";
}
</style>
